var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBikeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.275,
    y: 0.275,
    width: 21.45,
    height: 21.45,
    rx: 10.725,
    stroke: "#43419E",
    strokeWidth: 0.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#81rmom74qa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fu7qwn0n9b)",
    fill: "#43419E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.157 9.59H5.59a.168.168 0 0 1-.152-.096c-.168-.356-.32-.725-.158-.964.156-.232.535-.327 1.31-.327.494 0 1.118.04 1.777.081.82.052 1.747.11 2.66.11.06 0 .116.033.146.085.014.026.142.264.157.834.002.049 0 .09-.004.128a.168.168 0 0 1-.168.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.83 11.963-.1-.035a.17.17 0 0 1-.109-.126l-.106-.514a.168.168 0 0 1 .053-.16l.559-.498a.17.17 0 0 1 .108-.043l.68-.014c.136-.116.533-.456.711-.606a.168.168 0 0 1 .108-.039h5.145a.168.168 0 0 1 .158.225c-.043.12-.13.223-.25.365-.129.152-.306.36-.511.69a.773.773 0 0 0-.082.717c.146.378.55.672.787.74.188.053.51.085.862.085.557 0 1.135-.078 1.63-.221.916-.265 1.09-2.325.993-2.681-.054-.199-.295-.859-.528-1.497l-.173-.472-.073.05a.167.167 0 0 1-.232-.053.168.168 0 0 1 .052-.232s.061-.04.134-.095a39.567 39.567 0 0 1-.09-.254.067.067 0 0 0-.009.002.166.166 0 0 1-.117.112c-.243.06-.47.142-.473.143a.167.167 0 0 1-.216-.101.168.168 0 0 1 .101-.215c.01-.004.246-.09.508-.153a.163.163 0 0 1 .147.037.856.856 0 0 1-.055-.217c0-.314 1.171-.746 1.536-.758.107 0 .201.044.272.129.263.313.122 1.195.092 1.369a.168.168 0 0 1-.146.137l-.44.055c.148.471.805 1.933.945 2.151.034.048.255.087.361.106.228.04.443.079.525.242.083.168.077.452.066.609.025-.001.05-.005.075-.005.78 0 1.505.42 1.894 1.093.086.148.1.29.043.425-.06.139-.203.258-.395.366.256.32.41.724.41 1.165 0 1.032-.84 1.872-1.872 1.872a1.874 1.874 0 0 1-1.864-2.022 4.895 4.895 0 0 0-.447.196c-.061.033-.112-.003-.123-.053a2.295 2.295 0 0 1-.036-.285c-.498.405-1.031.433-1.817.433h-4.34a2.055 2.055 0 0 1-2.024 1.73 2.055 2.055 0 0 1-2.044-2.231c-.597-.085-.694-.183-.74-.232a.241.241 0 0 1-.074-.18c.014-.373.345-.954.532-1.252zm11.948 2.024c0 .568.462 1.03 1.03 1.03a1.028 1.028 0 0 0 .603-1.861c-.309.091-.648.177-.997.263a70.5 70.5 0 0 0-.539.136c-.06.133-.097.277-.097.432zm-10.832-.182a1.213 1.213 0 0 0 2.423 0 44.772 44.772 0 0 1-2.413-.098c-.003.033-.01.065-.01.098z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "81rmom74qa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.3 3.3)",
    d: "M0 0h15.4v15.4H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fu7qwn0n9b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 18.7 3.3)",
    d: "M0 0h15.4v15.4H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikeIcon);
export default __webpack_public_path__ + "static/media/bike-icon.4b91ecc2.svg";
export { ForwardRef as ReactComponent };